import "./mention.css";
import React, { useEffect, useState } from "react";
import { MentionsInput, Mention } from "react-mentions";
import mentionStyle from "./mentionStyle";
import * as IdKey from "short-uuid";

const MentionInput = ({
  mentions = [],
  label = "",
  isError,
  errorMessage,
  readOnly,
  inputChange,
  preValue = "",
}) => {
  const [textMention, setTextMention] = useState(preValue);
  const id = IdKey.generate();

  const handleMentionChange = (event) => {
    inputChange(event.target.value);
    setTextMention(event.target.value);
  };

  useEffect(() => {
    handleMentionChange({ target: { value: preValue } });
  }, [preValue]);

  useEffect(() => {
    const $mentionInput = document.querySelector(".mention-input__input");
    const $mentionLabel = document.querySelector(".mention-label");

    if (isError || !$mentionInput || !$mentionLabel || !!readOnly) return;

    $mentionInput.addEventListener("focus", () => {
      $mentionLabel.setAttribute("style", "color: #1976d2");
    });

    $mentionInput.addEventListener("blur", () => {
      $mentionLabel.setAttribute("style", "color: #757575");
    });
  }, [isError, readOnly]);

  useEffect(() => {
    const $textArea = document.querySelector(".mention-input__input");

    if (!$textArea) return;

    if (!!readOnly) {
      $textArea.setAttribute("disabled", true);
      $textArea.setAttribute("readOnly", true);
      $textArea.classList.add("mention-input__input--readonly");

      return;
    }

    $textArea.classList.remove("mention-input__input--readonly");
    $textArea.removeAttribute("readOnly");
    $textArea.removeAttribute("disabled");
  }, [readOnly]);

  const labelError = isError ? "mention-label-error" : "";
  const inputError = isError ? "mention-input-error" : "";

  return (
    <label className="mention-content" id={id}>
      {label && <span className={`mention-label ${labelError}`}>{label}</span>}
      <MentionsInput
        style={mentionStyle}
        className={`mention-input ${inputError}`}
        value={textMention}
        onChange={handleMentionChange}
      >
        <Mention trigger="@" data={mentions} className="mention-error" />
      </MentionsInput>
      {isError && <span className="mention-message-error">{errorMessage}</span>}
    </label>
  );
};

export default MentionInput;
